import { useEffect, useState } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { fetchSimplePageByInternalTitle } from '../helpers/contentfulHelper';
import styles from '../styles/AccoyaPage.module.css';

const MaterialsCraftsmanshipPage = () => {
  const [page, setPage] = useState(null);

  useEffect(() => {
    const load = async () => {
      const data = await fetchSimplePageByInternalTitle('Materials & Craftsmanship');
      setPage(data);
    };
    load();
  }, []);

  const fields = page?.fields || {};
  const copy = fields.copy || null;

  return (
    <section className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <p className={styles.kicker}>What We Offer</p>
          <h1>Materials &amp; Craftsmanship</h1>
        </header>

        <section className={styles.section}>
          {copy ? (
            <div className={styles.richText}>{documentToReactComponents(copy)}</div>
          ) : (
            <div className={styles.richText}>
              <p>Page content is coming soon.</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
};

export default MaterialsCraftsmanshipPage;
